import type { SmsDirectSendBody } from '@mathflat/domain/Sms'

import { DTO } from '../DTO'

export class SmsPost extends DTO implements SmsDirectSendBody {
  sendingTarget: SmsDirectSendBody['sendingTarget']
  studentIdList: SmsDirectSendBody['studentIdList']
  content: SmsDirectSendBody['content']

  constructor(data: SmsDirectSendBody) {
    super()
    this.sendingTarget = data.sendingTarget
    this.studentIdList = data.studentIdList
    this.content = data.content
  }
}
